/**
 * Catalog status enforcement - the single place that decides what "inactive"
 * means. An inactive category (or commodity) is RETIRED FROM VIEW: it
 * disappears from user-facing pickers, filter options and public showcase
 * surfaces, while everything already recorded stays visible - price history
 * rows, existing alerts and existing holdings keep resolving their names.
 * Use these helpers for OPTION LISTS only, never for display joins.
 */

export const isCategoryActive = (cat) => (cat?.status || 'active') !== 'inactive';

export const isCommodityActive = (commodity, categories) => {
  if ((commodity?.status || 'active') === 'inactive') return false;
  const cat = (categories || []).find((c) => c.id === commodity?.category);
  return !cat || isCategoryActive(cat);
};

export const activeCategories = (categories) => (categories || []).filter(isCategoryActive);

export const activeCommodities = (commodities, categories) =>
  (commodities || []).filter((c) => isCommodityActive(c, categories));
